import React, { useEffect, useState, useContext, forwardRef  } from "react";
import {
    Bar,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    ComposedChart,
    Legend,
} from "recharts";
import { Refresh } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import { AuthenticationContext } from "../../../../../context/AuthenticationContext";
import { BusinessApi } from "../../../../../api/Api";

// const BusinessInnerChart1 = () => {

    const BusinessInnerChart1 = forwardRef((props, ref) => {

    const { LoggedInUserInfo } = useContext(AuthenticationContext);
    const [chartData, setChartData] = useState([]);
    const [loading, setLoading] = useState(false);

    const getCredentials = () => ({
        LOGIN_ID: localStorage.getItem("business_LOGIN_ID") || "",
        SS_KEY: localStorage.getItem("business_SS_KEY") || "",
    });

    const fetchLogData = async () => {
        setLoading(true);
        const credentials = getCredentials();
        try {
            const res = await BusinessApi(credentials);

            if (res?.data && Array.isArray(res.data)) {
                const transformedData = res.data.map((item, index) => ({
                    name: item.user || `User-${index + 1}`,
                    Todays_KWh: parseFloat(item.TODAYS_KWH) || 0,
                    Todays_CUF: parseFloat(item.TODAYS_CUF) || 0,
                }));
                setChartData(transformedData);
            } else {
                setChartData([]);
                console.error("Data structure mismatch:", res);
            }
        } catch (err) {
            console.error("Error fetching data:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogData();
    }, []);

    return (
        <div ref={ref} className="row">
            <div className="col-md-12" style={{ height: "26rem", position: "relative" }}>
                {/* Refresh Button */}
                <div
                    style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        zIndex: 1,
                    }}
                >
                    <IconButton onClick={fetchLogData} disabled={loading}>
                        <Refresh />
                    </IconButton>
                    {loading && <CircularProgress size={24} style={{ marginLeft: "10px" }} />}
                </div>

                {/* Chart */}
                {loading ? (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        <CircularProgress />
                    </div>
                ) : (
                    <ResponsiveContainer>
                        <ComposedChart
                            data={chartData}
                            margin={{ top: 20, right: 40, left: 40, bottom: 60 }} // 👈 increase bottom for x-axis label
                        >
                            <CartesianGrid strokeDasharray="3 3" />

                            {/* X Axis (Inverter Names) */}
                            <XAxis
                                dataKey="name"
                                angle={-45}
                                textAnchor="end"
                                height={70}
                                tick={{ fontSize: 12, fill: "black" }}
                                label={{
                                    value: "Inverters",   // 👈 Static label for X-axis
                                    position: "insideBottom",
                                    offset: -50,
                                    fill: "white",
                                }}
                            />

                            {/* Y Axis for Today kWh (Left) */}
                            <YAxis
                                yAxisId="left"
                                tick={{ fontSize: 12, fill: "black" }}
                                label={{
                                    value: "Todays kWh",
                                    angle: -90,
                                    position: "insideLeft",
                                    fill: "black",
                                }}
                            />

                            {/* Y Axis for CUF (Right) */}
                            <YAxis
                                yAxisId="right"
                                orientation="right"
                                tick={{ fontSize: 12, fill: "black" }}
                                label={{
                                    value: "Todays CUF",
                                    angle: 90,
                                    position: "insideRight",
                                    fill: "black",
                                }}
                            />

                            {/* Tooltip & Legend */}
                            <Tooltip />
                            <Legend
                                layout="horizontal"
                                verticalAlign="top"
                                align="center"
                                wrapperStyle={{ fontSize: "12px", paddingBottom: "10px", color: "white" }}
                            />

                            {/* Bar: Today kWh */}
                            <Bar
                                dataKey="Todays_KWh"
                                yAxisId="left"
                                fill={LoggedInUserInfo?.dash_color || "#00C49F"}
                                name="Todays kWh"
                                barSize={30}
                            />

                            {/* Line: CUF */}
                            <Line
                                type="monotone"
                                dataKey="Todays_CUF"
                                yAxisId="right"
                                stroke="red"
                                strokeWidth={2}
                                dot={{ r: 3 }}
                                name="Todays CUF"
                            />
                        </ComposedChart>
                    </ResponsiveContainer>

                )}
            </div>
        </div>
    );
});

export default BusinessInnerChart1;
